import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CategoryGrid from '../components/CategoryGrid';
import { supabase } from '../supabase/client';
import { useNavigate } from 'react-router-dom';

/**
 * Home Page Component
 * Displays the Header, CategoryGrid, and Footer.
 * Manages user authentication state.
 * @returns {JSX.Element}
 */
const HomePage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('Home'); // State for bottom nav
  const navigate = useNavigate();

  // --- User State Management ---
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const { data: authListener } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        if (session) {
          setIsLoggedIn(true);
          setUserName(session.user?.email || 'User');
        } else {
          setIsLoggedIn(false);
          setUserName('');
          navigate('/login'); // Redirect to login if not authenticated
        }
      }
    );

    // Initial check for session
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        setIsLoggedIn(true);
        setUserName(session.user?.email || 'User');
      } else {
        navigate('/login'); // Redirect to login if no initial session
      }
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, [navigate]);

  const handleLogout = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) {
      console.error('Error logging out:', error.message);
    } else {
      setIsLoggedIn(false);
      setUserName('');
      console.log('User logged out.');
      navigate('/login'); // Redirect to login after logout
    }
  };
  // ----------------------------------

  return (
    <div className="min-h-screen bg-gray-900 flex justify-center p-0 sm:p-4">
      <div className="w-full max-w-sm bg-gray-800 shadow-2xl rounded-none sm:rounded-3xl relative overflow-hidden flex flex-col">
        
        {/* Composition: 1. Header */}
        <Header 
            isLoggedIn={isLoggedIn}
            userName={userName}
            onLogout={handleLogout}
        />
        
        {/* Composition: 2. Main Content (Category Grid) */}
        <CategoryGrid onSelectCategory={(categoryId: string) => navigate(`/shops/${categoryId}`)} />

      </div>
    </div>
  );
};

export default HomePage;
